export var LanguageList = [
    { value: 'en_US', label: 'English (Americas)' },
    { value: 'en_CA', label: 'English (Canada)' },
    { value: 'en_UK', label: 'English (UK)' },
    { value: 'fr_CA', label: 'Français (Canada)' },
    { value: 'fr_FR', label: 'Français (France)' },
    { value: 'es_ES', label: 'Español (Spain)' },
    { value: 'es_419', label: 'Español (Latin America)' },
    { value: 'es_MX', label: 'Español (Mexico)' },
    { value: 'es_AR', label: 'Español (Argentina)' },
];
//# sourceMappingURL=languageList.js.map